export default function Container({
  children,
  className = "",
  size = "default",
}) {
  const widths = {
    default: "max-w-container",
    content: "max-w-content",
    reading: "max-w-reading",
  };

  return (
    <div
      className={`
        ${widths[size]}
        mx-auto
        w-full
        px-6 lg:px-8
        ${className}
      `}
    >
      {children}
    </div>
  );
}